var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h;
import { E as EntityType } from "./enums-86f58524.js";
import { Schema, Component, type } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
var _a, _b, _c, _d, _e, _f, _g;
let SpatialMapSchema = (_h = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "spatialMap");
    __publicField(this, _a2);
    __publicField(this, _b2);
    __publicField(this, _c2);
    __publicField(this, _d2);
    __publicField(this, _e2);
    __publicField(this, _f2);
    __publicField(this, _g2);
    __publicField(this, "pointSets");
  }
}, _a2 = _a = EntityType.INTERACTABLE, _b2 = _b = EntityType.ENEMY, _c2 = _c = EntityType.PICKUP, _d2 = _d = EntityType.ALLY, _e2 = _e = EntityType.PROJECTILE, _f2 = _f = EntityType.WALL, _g2 = _g = EntityType.WEAPON, _h);
__decorateClass([
  type("object")
], SpatialMapSchema.prototype, "spatialMap", 2);
__decorateClass([
  type("object")
], SpatialMapSchema.prototype, _a, 2);
__decorateClass([
  type("object")
], SpatialMapSchema.prototype, _b, 2);
__decorateClass([
  type("object")
], SpatialMapSchema.prototype, _c, 2);
__decorateClass([
  type("object")
], SpatialMapSchema.prototype, _d, 2);
__decorateClass([
  type("object")
], SpatialMapSchema.prototype, _e, 2);
__decorateClass([
  type("object")
], SpatialMapSchema.prototype, _f, 2);
__decorateClass([
  type("object")
], SpatialMapSchema.prototype, _g, 2);
__decorateClass([
  type("object")
], SpatialMapSchema.prototype, "pointSets", 2);
SpatialMapSchema = __decorateClass([
  Component("SpatialMap")
], SpatialMapSchema);
const __vite_glob_0_8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get SpatialMapSchema() {
    return SpatialMapSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  SpatialMapSchema as S,
  __vite_glob_0_8 as _
};
//# sourceMappingURL=SpatialMap-56228ece.js.map
